import { styled as t, Box as s, Typography as x } from "@mui/material";
import w from "../../assets/icon-apeiron-logo-simplified.svg.js";
import { useAuthLibContext as y } from "../../contexts/AuthLibContext.js";
import b from "../../hooks/useFetchDownloadMap.js";
import { DownloadStatus as k } from "../../../download-lib/constants/download.js";
import C from "../../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import u from "../../../temp-lib/components/share/next/Image.js";
import { PlatformType as S } from "../../../temp-lib/constants/platform.js";
import { noForwardProps as O } from "../../../temp-lib/util/styled/index.js";
import { QRCodeSVG as L } from "qrcode.react";
import * as o from "ramda";
import { useMemo as g } from "react";
import { useTranslation as R } from "react-i18next";
import { jsxs as d, jsx as n, Fragment as I } from "react/jsx-runtime";
const T = t(s)`
  aspect-ratio: 2.66;
  background-color: #000000aa;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  max-width: 480px;

  ${(e) => e.theme.breakpoints.up("res1280")} {
    padding: 22px 35px;
    width: calc(100% - 40px);
  }
  ${(e) => e.theme.breakpoints.down("res1280")} {
    padding: 16px 8px;
    width: calc(100% - 20px);
  }
`, _ = t(x)`
  margin: -10px 0 10px 0;
`, j = t(s)`
  display: flex;
  width: 100%;
  gap: 10px;
`, v = t(s)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
`, D = t(s)`
  display: flex;
  align-items: center;
  width: calc(50% - 5px);
`, Q = t(s)`
  align-items: center;
  aspect-ratio: 1;
  background-color: white;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  width: 30%;
`, z = t(L)`
  height: unset;
  padding: 4px;
`, A = t(C, O)`
  --background-color: white;
  border-radius: 4px;
  gap: 10px;
  height: 40px;
  justify-content: flex-start;
  width: 100%;

  ${(e) => e.__comingSoon && "pointer-events: none;"}
`, B = t(u)`
  height: 90%;
  width: 100%;
`, F = t(u)`
  aspect-ratio: 1;
  height: 32px;
  margin-left: 16.5%;
`, G = t(s)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`, N = t(x)`
  color: black;
  font-size: 10px;
  font-weight: 500;
  text-align: left;
  margin-bottom: -4px;
  white-space: nowrap;
`, P = t(x)`
  color: black;
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
`, $ = (e) => {
  const {
    info: r,
    key: m
  } = e, i = o.propOr("", "status", r) === k.ComingSoon, h = i ? "" : o.pathOr("", ["build", "url"], r), a = o.pathOr("", ["platform", "icon", "normal"], r), p = o.pathOr("", ["platform", "icon", "long"], r), f = o.pathOr("", ["platform", "name"], r), c = o.propOr(!1, "imageOnly", r), l = o.propOr(!1, "statusText", r);
  return /* @__PURE__ */ n(A, {
    url: h,
    target: "_blank",
    __comingSoon: i,
    children: c ? /* @__PURE__ */ n(B, {
      src: p
    }) : /* @__PURE__ */ d(I, {
      children: [/* @__PURE__ */ n(F, {
        src: a
      }), /* @__PURE__ */ d(G, {
        children: [!o.isEmpty(l) && /* @__PURE__ */ n(N, {
          children: l
        }), /* @__PURE__ */ n(P, {
          children: f
        })]
      })]
    })
  }, m);
}, ot = (e) => {
  const {
    className: r
  } = e, {
    t: m
  } = R(), {
    config: i
  } = y(), {
    showQRCode: h
  } = (i == null ? void 0 : i.download) || {}, {
    data: a
  } = b(), p = g(() => (a == null ? void 0 : a.login) || [], [a]), f = g(() => {
    const c = o.find((l) => l.platform.type === S.Epic, p);
    return o.pathOr("", ["build", "url"], c);
  }, [p]);
  return /* @__PURE__ */ d(T, {
    className: r,
    children: [/* @__PURE__ */ n(_, {
      children: m("login.general.client_title")
    }), /* @__PURE__ */ d(j, {
      children: [h && /* @__PURE__ */ n(Q, {
        children: /* @__PURE__ */ n(z, {
          size: 138,
          level: "L",
          value: f,
          imageSettings: {
            src: w,
            excavate: !0,
            width: 18,
            height: 18
          }
        })
      }), /* @__PURE__ */ n(v, {
        children: o.map((c) => /* @__PURE__ */ n(D, {
          children: /* @__PURE__ */ n($, {
            info: c
          })
        }, c.platform.type), p)
      })]
    })]
  });
};
export {
  ot as default
};
//# sourceMappingURL=LoginGameClientSection.js.map
